module.exports = __webpack_public_path__ + "static/media/Motorola Moto 360 Women Rose Gold + Stone Grey Closed.ef5130fa.png";